/* Pure project rules, shared by the theme and the Rasmine service. */
(function (scope) {
  'use strict';
  const clean = (v, max = 600) => typeof v === 'string' ? v.trim().slice(0, max) : '';
  const id = v => /^\d{1,20}$/.test(String(v)) ? String(v) : null;
  function normalize(raw) {
    const seen = new Set();
    const items = (Array.isArray(raw?.items) ? raw.items : []).slice(0, 20).flatMap(x => {
      const variantId = id(x?.variantId), handle = clean(x?.handle, 180);
      if (!variantId || !/^[a-z0-9][a-z0-9-]*$/.test(handle) || seen.has(variantId)) return [];
      seen.add(variantId);
      return [{ variantId, handle, quantity: Math.max(1, Math.min(20, Math.round(Number(x.quantity) || 1))), owned: x.owned === true }];
    });
    return { version: 1, goal: clean(raw?.goal), country: ['DK','SE','OTHER'].includes(raw?.country)?raw.country:'', use: ['walk','home','learn'].includes(raw?.use) ? raw.use : '', positioning: raw?.positioning === true, items };
  }
  function add(project, handle, variantId) {
    const next = normalize(project), valid = id(variantId);
    if (!valid) return next;
    const exists = next.items.find(x => x.variantId === valid);
    if (exists) exists.quantity = Math.min(20, exists.quantity + 1);
    else if (next.items.length < 20) next.items.push({handle,variantId:valid,quantity:1,owned:false});
    return normalize(next);
  }
  function total(project, products) {
    let cents = 0, unresolved = 0;
    for (const item of normalize(project).items) {
      if (item.owned) continue;
      const variant = products.find(p => p.handle === item.handle)?.variants?.find(v => String(v.id) === item.variantId);
      if (!variant || !Number.isFinite(variant.price)) { unresolved++; continue; }
      cents += variant.price * item.quantity;
    }
    return { cents, unresolved };
  }
  function selectedVariants(project, products) {
    return normalize(project).items.filter(x => !x.owned).map(item => {
      const product = products.find(p => p.handle === item.handle);
      const variant = product?.variants?.find(v => String(v.id) === item.variantId);
      if (!variant?.available) throw new Error('unavailable');
      return { id: item.variantId, quantity: item.quantity };
    });
  }
  function cartDelta(wanted,cartItems){return wanted.map(item=>{const existing=(Array.isArray(cartItems)?cartItems:[]).filter(x=>String(x.variant_id)===String(item.id)).reduce((sum,x)=>sum+Math.max(0,Number(x.quantity)||0),0);return {id:item.id,quantity:Math.max(0,item.quantity-existing)};}).filter(x=>x.quantity>0);}
  scope.RasmineCore = { clean, normalize, add, total, selectedVariants, cartDelta };
})(globalThis);
